//test
export const getCount = state => {
    return state.count
}

export const groupid = state => {
    return state.groupid
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js